
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[query]",
      function () {
        return require("private-next-pages/blog/[query].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/[query]"])
      });
    }
  